import LandingPage from "./pages/landing-page/LandingPage";

import { createBrowserRouter } from "react-router-dom";
import RouteDoesntExist from "./fallbacks/RouteDoesntExist";
import ProviderDashboard from "./pages/provider/dashboard/ProviderDashboard";
import PublicLayoutFinalization from "./layouts/public-layout-finalization/PublicLayoutFinalization";
import SignUpProvider from "./pages/provider/sign-up/SignUpProvider";
import SignUpProviderConfirmation from "./pages/provider/sign-up-confimation/SignUpProviderConfirmation";
import LoginProvider from "./pages/login/Login";
import ForgotPassword from "./pages/forgotPassword/ForgotPassword";
import CompanyFirstLogin from "./pages/provider/company-first-login/CompanyFirstLogin";
import ProductsPage from "./pages/provider/products/ProductsPage";
import ProviderGuard from "./guards/ProviderGuard";
import CreateProduct from "./pages/provider/products/CreateProduct";
import EditProduct from "./pages/provider/products/EditProduct";
import LogoutHandler from "./LogoutHandler";
import TeamMembers from "./pages/provider/team-member/TeamMembers";
import AddTeamMember from "./pages/provider/team-member/add-team-member/AddTeamMember";
import ConfirmTeamMember from "./pages/provider/team-member/confirm-team-member/ConfirmTeamMember";

import { ApplicationRoutes } from "./routes";
import PrivateLayout from "./layouts/private-layout/PrivateLayout";
import AdminGuard from "./guards/AdminGuard";
import CustomerRegistration from "./pages/customer/customer-registration/CustomerRegistration";
import SolarProvider from "./pages/admin/solar-provider/SolarProvider";
import SearchParameters from "./pages/admin/appliances/SearchParameters";
import LoanProductsPage from "./pages/admin/loan-products/LoanProductsPage";
import LoanRequestPage from "./pages/admin/loan-request/LoanRequestPage";
import ProductBrowserPage from "./pages/customer/product-browser/ProductBrowserPage";
import PublicLayoutProducts from "./layouts/public-layout-products/PublicLayoutProducts";
import SolarRecommendation from "./pages/customer/solar-recommendation/SolarRecommendation";
import ProductListPage from "./pages/customer/product-list/ProductListPage";
import SolarSystemDetails from "./pages/customer/solar-system-details/SolarSystemDetails";
import SolarProductConfirmation from "./pages/customer/solar-system-details/solar-product-confirmation/SolarProductConfirmation";
import CustomerGuard from "./guards/CustomerGuard";
import CustomerDashboard from "./pages/customer/dashboard/CustomerDashboardPage";
import CustomerOrders from "./pages/customer/orders/CustomerOrdersPage";
import ProviderCustomers from "./pages/provider/customer/CustomerPage";
import AdminCustomerPage from "./pages/admin/customer/AdminCustomerPage";
import CustomerPaymentsPage from "./pages/customer/payments/CustomerPaymentsPage";
import AdminDashboard from "./pages/admin/dashboard/AdminDashboard";
import LoanSummaryPage from "./pages/admin/loan-summary/LoanSummaryPage";
import PublicLayoutLanding from "./layouts/public-layout-landing/PublicLayoutLanding";
import Terms from "./pages/terms";
import ComingSoonPage from "./pages/coming-soon";
import PublicFormLayout from "./layouts/public-form-layout/PublicFormLayout";
import UserInfoStep from "./pages/sign-up/UserInfoStep";
import VerifyOtpStep from "./pages/sign-up/VerifyOtpStep";
import SignUpSelectNextStep from "./pages/sign-up/SignUpSelectNextStep";
import TestCanvas from "./pages/test/TestCanvas";
import StoreFrontLayout from "./pages/store-front/layout/StoreFrontLayout";
import StoreFront from "./pages/store-front/StoreFront";
import StoreFrontItem from "./pages/store-front/item/StoreFrontItem";
import ProductCategoryPage from "./pages/admin/products/category";
import SelectNextStep from "./pages/next-step/SelectNextStep";
import StoreFrontCategory from "./pages/store-front/category/StoreFrontCategory";
import RoofTypePage from "./pages/admin/roof-type";
import AdvertBannerPage from "./pages/admin/advert-banner/AdvertBannerPage";
import ConfirmOrder from "./pages/store-front/confirm-order/ConfirmOrder";
import ScrollToTop from "./common/components/scroll-to-top/ScrollToTop";
import Checkout from "./pages/store-front/checkout/Checkout";
import GuestOrCustomerGuard from "./guards/GuestOrCustomerGuard";
import WishlistPage from "./pages/store-front/wishlist";
import BillingInfoPage from "./pages/store-front/billing-info";
import ConfirmPayment from "./pages/store-front/confirm-payment/ConfirmPayment";
import ApplianceCategory from "./pages/admin/appliances/ApplianceCategory";
import PrivacyPolicyPage from "./pages/terms/PrivacyPolicy";
import DeleteInstructionPage from "./pages/terms/DeleteInstruction";

export const router = createBrowserRouter([
	{
		element: (
			<>
				<ScrollToTop />
				<LogoutHandler />
			</>
		),
		children: [
			{
				path: ApplicationRoutes.LANDING_PAGE,
				element: <PublicLayoutLanding />,
				children: [
					{
						path: "",
						element: <LandingPage />,
					},
					{
						path: ApplicationRoutes.TERMS,
						element: <Terms />,
					},
					{
						path: ApplicationRoutes.PRIVACY_POLICY,
						element: <PrivacyPolicyPage />,
					},
					{ 
						path:ApplicationRoutes.DELETE_INSTRUCTION,
						element: <DeleteInstructionPage />
					},
					{ path: ApplicationRoutes.COMING_SOON, element: <ComingSoonPage /> },
				],
			},
			{
				path: "/test",
				element: <TestCanvas />,
			},
			{
				element: <StoreFrontLayout />,
				children: [
					{
						path: ApplicationRoutes.STORE_FRONT,
						element: <StoreFront />,
					},
					{
						path: ApplicationRoutes.STORE_FRONT_CATEGORY,
						element: <StoreFrontCategory />,
					},
					{
						path: `${ApplicationRoutes.STORE_FRONT_ITEM}/:id`,
						element: <StoreFrontItem />,
					},
					{
						element: <GuestOrCustomerGuard />,
						children: [
							{
								path: ApplicationRoutes.CONFIRM_ORDER,
								element: <ConfirmOrder />,
							},
							{
								path: ApplicationRoutes.CHECKOUT,
								element: <Checkout />,
							},
							{
								path: ApplicationRoutes.WISHLIST,
								element: <WishlistPage />,
							},
							{
								path: ApplicationRoutes.BILLING_INFO,
								element: <BillingInfoPage />
							},
							{
								path: ApplicationRoutes.CONFIRM_PAYMENT,
								element: <ConfirmPayment />
							},
						],
					},		
				]
			},
			{
				path: ApplicationRoutes.PROVIDER_SIGNUP_CONFIRMATION,
				element: <SignUpProviderConfirmation />,
			},
			{
				element: <PublicFormLayout />,
				children: [
					{
						path: ApplicationRoutes.NEW_CUSTOMER_SIGNUP_USER_INFORMATION,
						element: <UserInfoStep />,
					},
					{
						path: ApplicationRoutes.NEW_CUSTOMER_SIGNUP_OTP,
						element: <VerifyOtpStep />,
					},
					{
						path: ApplicationRoutes.NEW_CUSTOMER_SIGNUP_NEXT_STEP,
						element: <SignUpSelectNextStep />,
					},
					{
						path: ApplicationRoutes.CUSTOMER_SIGNUP,
						element: <CustomerRegistration />,
					},
					{
						path: ApplicationRoutes.RECOMMENDATION,
						element: <SolarRecommendation />,
					},
				],
			},
			{
				element: <PublicLayoutProducts />,
				children: [
					{
						path: ApplicationRoutes.RECOMMENDATION_OVERVIEW,
						element: <ProductBrowserPage />,
					},
					{
						path: ApplicationRoutes.RECOMMENDATION_PRODUCTS,
						element: <ProductListPage />,
					},
					{
						path: ApplicationRoutes.RECOMMENDATION_PRODUCT_DETAILS,
						element: <SolarSystemDetails />,
					},
				],
			},
			{
				element: <PublicLayoutFinalization />,
				children: [
					{
						path: ApplicationRoutes.PROVIDER_SIGNUP,
						element: <SignUpProvider />,
					},
					{
						path: ApplicationRoutes.LOGIN,
						element: <LoginProvider />,
					},
					{
						path: ApplicationRoutes.FORGOT_PASSWORD,
						element: <ForgotPassword />,
					},
					{
						path: ApplicationRoutes.PROVIDER_TEAM_MEMBER_CONFIRMATION,
						element: <ConfirmTeamMember />,
					},
				],
			},
			{
				element: <ProviderGuard />,
				children: [
					{
						path: ApplicationRoutes.PROVIDER_BASE,
						element: <PrivateLayout />,
						children: [
							{
								path: ApplicationRoutes.DASHBOARD,
								element: <ProviderDashboard />,
							},
							{
								path: ApplicationRoutes.PROVIDER_CUSTOMERS,
								element: <ProviderCustomers />,
							},
							{
								path: `${ApplicationRoutes.PROVIDER_COMPANY_FIRST_LOGIN}:companyId`,
								element: <CompanyFirstLogin />,
							},
							{
								path: ApplicationRoutes.PRODUCTS,
								element: <ProductsPage />,
							},
							{
								path: ApplicationRoutes.CREATE_PRODUCT,
								element: <CreateProduct />,
							},
							{
								path: `${ApplicationRoutes.EDIT_PRODUCT}:id`,
								element: <EditProduct />,
							},
							{
								path: ApplicationRoutes.PROVIDER_TEAM_MEMBERS,
								element: <TeamMembers />,
							},
							{
								path: ApplicationRoutes.PROVIDER_ADD_TEAM_MEMBER,
								element: <AddTeamMember />,
							},
						],
					},
				],
			},
			{
				element: <AdminGuard />,
				children: [
					{
						path: ApplicationRoutes.ADMIN_BASE,
						element: <PrivateLayout />,
						children: [
							{
								path: ApplicationRoutes.DASHBOARD,
								element: <AdminDashboard />,
							},
							{
								path: ApplicationRoutes.LOAN_PRODUCTS,
								element: <LoanProductsPage />,
							},
							{
								path: ApplicationRoutes.LOAN_REQUEST,
								element: <LoanRequestPage />,
							},
							{
								path: ApplicationRoutes.SOLAR_PROVIDER,
								element: <SolarProvider />,
							},
							{
								path: ApplicationRoutes.SEARCH_PARAMETER,
								element: <SearchParameters />,
							},
							{
								path: ApplicationRoutes.APPLIANCE_CATEGORIES,
								element: <ApplianceCategory />,
							},
							{
								path: ApplicationRoutes.CUSTOMER_BASE,
								element: <AdminCustomerPage />,
							},
							{
								path: ApplicationRoutes.LOAN_SUMMARY,
								element: <LoanSummaryPage />,
							},
							{
								path: ApplicationRoutes.PRODUCTS_CATEGORY,
								element: <ProductCategoryPage />,
							},
							{
								path: ApplicationRoutes.ROOF_TYPE,
								element: <RoofTypePage />,
							},
							{
								path: ApplicationRoutes.ADVERT_BANNER,
								element: <AdvertBannerPage />,
							},
						],
					},
				],
			},
			{
				element: <CustomerGuard />,
				children: [
					{
						path: ApplicationRoutes.CUSTOMER_BASE,
						element: <PrivateLayout />,
						children: [
							{
								path: ApplicationRoutes.DASHBOARD,
								element: <CustomerDashboard />,
							},
							{
								path: ApplicationRoutes.CUSTOMER_ORDERS,
								element: <CustomerOrders />,
							},
							{
								path: ApplicationRoutes.PAYMENTS,
								element: <CustomerPaymentsPage />,
							},
						],
					},
					{
						element: <PublicLayoutProducts />,
						children: [
							{
								path: ApplicationRoutes.RECOMMENDATION_OVERVIEW,
								element: <ProductBrowserPage />,
							},
							{
								path: ApplicationRoutes.RECOMMENDATION_PRODUCTS,
								element: <ProductListPage />,
							},
							{
								path: ApplicationRoutes.RECOMMENDATION_PRODUCT_DETAILS,
								element: <SolarSystemDetails />,
							},
						],
					},
					{
						element: <PublicLayoutFinalization />,
						children: [
							// {
							// 	path: ApplicationRoutes.RECOMMENDATION_FINALIZATION,
							// 	element: <SolarRecommendationFinalization />,
							// },
							{
								path: ApplicationRoutes.RECOMMENDATION_PRODUCT_CONFIRMATION,
								element: <SolarProductConfirmation />,
							},
						],
					},
					{
						element: <PublicFormLayout />,
						children: [
							{
								path: ApplicationRoutes.NEW_CUSTOMER_SIGNUP_NEXT_STEP,
								element: <SignUpSelectNextStep />,
							},
							{
								path: ApplicationRoutes.CUSTOMER_NEXT_STEP,
								element: <SelectNextStep />,
							},
						],
					},
				],
			},
			{
				path: "*",
				element: <RouteDoesntExist />,
			},
		],
	},
]);
